export default Object.freeze({
  MAP_FRANCE_COMPARABLES: 1,
  TEST_FRANCE_COMPARABLES_TEST: 2,
  TALOS_SCOPE: 3,
  TALOS_PROPERTY_DETAIL: 4,
  TALOS_LEASE_COMPS_PROFILE_1ST_SECTION: 5,
  TALOS_LEASE_SALE_NEW_COMP: 6,
  TALOS_SALE_COMPS_PROFILE_2ND_SECTION: 7,
  TALOS_SALE_COMPS_PROFILE_1ST_SECTION: 8,
  TALOS_SALES_INFO_1ST_SECTION: 9,
  TALOS_SALES_INFO_2ND_SECTION: 10,
  TALOS_LAND_PROFILE_1ST_SECTION: 11,
  TALOS_LAND_PROFILE_2ND_SECTION: 12,
  TALOS_LAND_NEW_COMP: 13,
  TALOS_NEW_LEASE_COMMERCIAL_COMP: 15,
  TALOS_LEASE_COMPS_PROFILE_2ND_SECTION: 17,
  TALOS_IE_COMPS_PROFILE_1ST_SECTION: 18,
  TALOS_IE_COMPS_PROFILE_2ND_SECTION: 19,
  TALOS_SALES_PROFILE_3RD_SECTION_INDUSTRIAL: 20,
  TALOS_LEASE_PROFILE_3RD_SECTION_INDUSTRIAL: 21,
  TALOS_LEASE_NEW_MULTI_COMP: 22,
  TALOS_LEASE_NEW_COMM_COMP: 23,
  TALOS_NEW_GEOLOCALIZATION: 28,
  TALOS_GLOBAL_MANDATE_DETAIL_SCREEN: 29,
  TALOS_GLOBAL_MANDATE_CLIENTS_PARTY_DETAILS: 30,
  TALOS_NEW_GEOLOCALIZATION_PARENT_INFO: 31,
  TALOS_GLOBAL_MANDATE_RELIANT_PARTY_DETAILS: 33,
  TALOS_GLOBAL_PROPERTY_DETAILS: 32,
  PERSONAS_PERSONA_DETAILS: 100,
  PERSONAS_DOCUMENT_DETAILS: 101,
  USER_USER_SETTINGS: 102,
  PROPERTY_DOCUMENT_DETAILS: 200,
  CREATE_MANDATE_CREATE_NEW_MANDATE: 201,
  NEW_PROPERTY_CREATE_NEW_PROPERTY_MODAL_INSIDE_NEW_MANDATE: 202,
  TALOS_DASHBOARD: 203,
  COMPS_DOCUMENT_DETAILS: 300,
  TALOS_LEASE_PROFILE_VERIFICATION: 500,
  TALOS_LEASE_PROFILE_COMMENTS: 501,
  TALOS_SALES_LAND_COMMENTS: 502,
  APEX_API_TABLE_ATTRIBUTES_TO_INDICATE_SPECIFIC_VALUES_FOR_THE_APEX_TEMPLATE: 999,
});
